import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminApi } from "@/admin/adminApi";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  useEffect(() => {
    adminApi.get("/admin/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post("/admin/auth/login", { email, password });
    setUser(data);
  }, []);

  const logout = useCallback(async () => {
    await adminApi.post("/admin/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAdminAuth = () => useContext(AuthCtx);

export function RequireAdmin({ children }) {
  const { user } = useAdminAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div data-testid="admin-auth-loading" className="min-h-screen flex items-center justify-center bg-warm">
        <p className="font-serif-display italic text-graphite-soft text-[20px]">Betöltés…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/belepes" replace state={{ from: location.pathname }} />;
  return children;
}

export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}
